<script setup lang="ts">
import type { AddonCard } from '@/types/types'

withDefaults(
  defineProps<{
    addons: AddonCard[]
    hasAnimation: boolean
  }>(),
  {
    hasAnimation: true
  }
)

const { openInNewTab } = useDOM()
const { sendEvent } = useAddon()

const handleClick = (addon: AddonCard) => {
  if (addon.actionButton.link) {
    openInNewTab(addon.actionButton.link)
    sendEvent(addon.id, 'addons:clicked')
    return
  }
  emit('onClick', addon.id)
}

const emit = defineEmits<{ (e: 'onClick', id: number): void }>()
</script>

<template>
  <div
    v-for="addon in addons"
    :key="addon.slug"
    class="group col-span-6 flex cursor-pointer flex-col justify-between rounded-lg border border-border transition-colors duration-200 hover:border-primary md:col-span-3 lg:col-span-2"
    :class="hasAnimation && 'hover:shadow-[0_4px_14px_0_rgba(83,36,188,0.08)]'"
    @click="handleClick(addon)"
  >
    <div class="flex flex-col justify-start">
      <div
        v-if="addon.cover"
        class="h-56 rounded-lg rounded-b-none bg-cover bg-center"
        :style="{ backgroundImage: `url(${addon.cover})` }"
      ></div>
      <div class="p-5">
        <p class="mb-1 flex items-center text-base font-semibold text-foreground">
          <span v-html="addon.title" />
        </p>
        <div class="mb-4 flex flex-row space-x-2">
          <p class="rounded-md bg-primary/10 px-2 py-1.5 text-xs font-semibold leading-5 text-primary">
            <span v-html="addon.label"></span>
          </p>
        </div>
        <p class="mb-2 line-clamp-4 text-sm text-foreground">
          <span v-html="addon.description" />
        </p>
      </div>
    </div>
    <div class="flex flex-row justify-end border-t p-3 border-t-border text-primary">
      <p class="rounded-md border-2 px-5 py-2 text-sm font-medium group-hover:bg-primary/5 group-hover:text-primary">
        {{ addon.actionButton.text }}
      </p>
    </div>
  </div>
</template>
